import {useCallback,useEffect,useRef,useState} from 'react';
export default function useArcadeAudio(paused,onError){
 const [enabled,setEnabled]=useState(false);
 const active=useRef(false),music=useRef(null),context=useRef(null),breakBuffer=useRef(null),mounted=useRef(true);
 const tone=useCallback((kind)=>{
  const ctx=context.current;
  if(!active.current||!ctx)return;
  const play=()=>{
   if(!active.current||ctx.state!=='running')return;
   if(kind==='unlock'&&breakBuffer.current){
    const source=ctx.createBufferSource(),gain=ctx.createGain();source.buffer=breakBuffer.current;gain.gain.value=.65;
    source.connect(gain);gain.connect(ctx.destination);source.start();source.onended=()=>{source.disconnect();gain.disconnect();};return;
   }
   const notes=kind==='pipe'?[[330,0,.09],[247,.09,.09],[165,.18,.12],[110,.30,.16]]:kind==='coin'?[[988,0,.07],[1319,.07,.18]]:kind==='jump'?[[220,0,.06],[440,.06,.06],[660,.12,.1]]:[[180,0,.06],[110,.06,.07],[65,.13,.13]];
   notes.forEach(([hz,delay,length])=>{
    const osc=ctx.createOscillator(),gain=ctx.createGain(),start=ctx.currentTime+delay;
    osc.type=kind==='unlock'?'sawtooth':'square';osc.frequency.value=hz;gain.gain.setValueAtTime(.07,start);gain.gain.exponentialRampToValueAtTime(.001,start+length);
    osc.connect(gain);gain.connect(ctx.destination);osc.start(start);osc.stop(start+length);osc.onended=()=>{osc.disconnect();gain.disconnect();};
   });
  };
  if(ctx.state==='suspended')ctx.resume().then(play).catch(()=>{});else play();
 },[]);
 const enable=useCallback(async()=>{
  if(active.current)return;
  try{
   const AudioContext=window.AudioContext||window.webkitAudioContext;
   if(AudioContext&&!context.current)context.current=new AudioContext();
   if(!music.current){music.current=new Audio(`${process.env.PUBLIC_URL||''}/song.mp3`);music.current.loop=true;music.current.volume=.15;}
   active.current=true;
   const resume=context.current?.resume();
   const playback=music.current.play().catch(()=>{if(mounted.current&&active.current)onError('Sound effects are on. Tap Sound off, then on to retry music.');});
   if(context.current&&!breakBuffer.current){
    const ctx=context.current;
    fetch(`${process.env.PUBLIC_URL||''}/break.mp3`).then(r=>{if(!r.ok)throw new Error('Audio unavailable');return r.arrayBuffer();}).then(bytes=>ctx.decodeAudioData(bytes)).then(buffer=>{if(mounted.current)breakBuffer.current=buffer;}).catch(()=>{});
   }
   await Promise.all([resume,playback]);
   if(mounted.current&&active.current){setEnabled(true);tone('coin');}
  }catch{active.current=false;music.current?.pause();if(mounted.current){setEnabled(false);onError('Audio could not start. Tap Sound to retry.');}}
 },[onError,tone]);
 const toggle=useCallback(()=>{
  if(active.current){active.current=false;music.current?.pause();context.current?.suspend().catch(()=>{});setEnabled(false);}
  else enable();
 },[enable]);
 useEffect(()=>{
  if(!enabled||!music.current)return;
  if(paused)music.current.pause();
  else{context.current?.resume().catch(()=>{});music.current.play().catch(()=>{if(mounted.current)onError('Sound effects are on; music could not resume. Toggle Sound to retry.');});}
 },[paused,enabled,onError]);
 useEffect(()=>{mounted.current=true;return ()=>{mounted.current=false;active.current=false;music.current?.pause();if(music.current){music.current.src='';music.current.load();}context.current?.close().catch(()=>{});};},[]);
 return {enabled,toggle,enable,tone};
}
